/* GlobifySIM – Prüfung, ob ein Gerät eSIM unterstützt */
(function () {
  "use strict";

  var SPRACHE = (document.documentElement.lang || "de").slice(0, 2).toLowerCase();
  var T = (window.GST || {});

  function flach(wert) {
    var t = String(wert == null ? "" : wert).toLowerCase();
    t = t.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss");
    if (t.normalize) t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return t.replace(/[^a-z0-9]+/g, " ").replace(/^ +| +$/g, "");
  }

  function hinweis(g) {
    return g.hinweis || "";
  }

  function suchen(eingabe, grenze) {
    var q = flach(eingabe);
    if (!q) return [];
    var teile = q.split(" ").filter(Boolean);
    var treffer = [];
    var q_eng = q.replace(/ /g, "");
    (window.GS_GERAETE || []).forEach(function (g) {
      var heu = flach(g.such);
      var woerter = heu.split(" ");
      var punkte = 0;
      if (heu === q) punkte = 100;
      else if (heu.indexOf(q) >= 0) punkte = 70;
      else if (teile.length && teile.every(function (t) { return woerter.indexOf(t) >= 0; })) punkte = 55;
      else if (heu.replace(/ /g, "").indexOf(q_eng) >= 0) punkte = 45;
      if (punkte) treffer.push({ geraet: g, punkte: punkte });
    });
    treffer.sort(function (a, b) { return b.punkte - a.punkte; });
    return treffer.slice(0, grenze || 6).map(function (t) { return t.geraet; });
  }

  function plakette(status) {
    var beschriftung = { ja: "eSIM", teilweise: "?", nein: "—" };
    var s = document.createElement("span");
    s.className = "gs-plakette gs-plakette--" + status;
    s.textContent = beschriftung[status] || status;
    return s;
  }

  function aufbauen(wurzel) {
    var feld = wurzel.querySelector("[data-gs-geraet-feld]");
    var knopf = wurzel.querySelector("[data-gs-geraet-knopf]");
    var kasten = wurzel.querySelector("[data-gs-geraet-ergebnis]");
    var liste = wurzel.querySelector("[data-gs-geraet-liste]");
    if (!feld || !kasten) return;

    var titel = kasten.querySelector("[data-gs-geraet-titel]");
    var text = kasten.querySelector("[data-gs-geraet-text]");

    function anzeigen(status, kopf, unten) {
      kasten.setAttribute("data-status", status);
      kasten.classList.add("ist-sichtbar");
      if (titel) titel.textContent = kopf;
      if (text) text.textContent = unten;
    }

    function pruefen() {
      var wert = feld.value.trim();
      if (!wert) { kasten.classList.remove("ist-sichtbar"); zeichnen(""); return; }
      var gefunden = suchen(wert, 6);
      zeichnen(wert);
      if (!gefunden.length) {
        anzeigen("unbekannt", T.g_unbekannt || "Unknown device", T.g_sim_lock || "");
        return;
      }
      var g = gefunden[0];
      var kopf = g.marke + " " + g.modell;
      var unten;
      if (g.status === "ja") unten = (T.g_ja || "") + " " + (hinweis(g) ? hinweis(g) + " " : "") + (T.g_sim_lock || "");
      else if (g.status === "teilweise") unten = (T.g_teilweise || "") + " " + (hinweis(g) ? hinweis(g) + " " : "") + (T.g_sim_lock || "");
      else unten = (T.g_nein || "") + " " + hinweis(g);
      anzeigen(g.status, kopf, unten.replace(/\s+/g, " ").trim());
    }

    function zeichnen(eingabe) {
      if (!liste) return;
      var alle = eingabe ? suchen(eingabe, 12) : (window.GS_GERAETE || []).slice(0, 12);
      liste.innerHTML = "";
      alle.forEach(function (g) {
        var zeile = document.createElement("div");
        zeile.className = "gs-geraet-zeile";
        zeile.appendChild(plakette(g.status));
        var b = document.createElement("b");
        b.style.fontWeight = "500";
        b.textContent = g.modell;
        zeile.appendChild(b);
        var m = document.createElement("span");
        m.className = "gs-marke";
        m.textContent = g.marke;
        zeile.appendChild(m);
        liste.appendChild(zeile);
      });
    }

    feld.addEventListener("input", function () {
      if (feld.value.trim().length >= 3) pruefen();
      else { kasten.classList.remove("ist-sichtbar"); zeichnen(""); }
    });
    feld.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); pruefen(); }
    });
    if (knopf) knopf.addEventListener("click", function (e) { e.preventDefault(); pruefen(); });

    zeichnen("");
  }

  window.GSCheck = { suchen: suchen, flach: flach };

  document.addEventListener("DOMContentLoaded", function () {
    var alle = document.querySelectorAll("[data-gs-geraetecheck]");
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  });
})();
